<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                <span>新建评价</span>
            </div>
            <div class="right"></div>
        </div>
        <div>
            <el-form :inline="false" :model="queryParams" label-width="70px">
                <el-form-item label="评价名称">
                    <el-input v-model="queryParams.name" placeholder="请输入学生姓名"></el-input>
                </el-form-item>
				<el-form-item label="评价类型">
                    <el-select v-model="queryParams.type" clearable placeholder="请选择评价类型" class="label">
                        <el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
					<p>
						无合适类型时请到
						<a href="javascript:;" style="color:#4991e1">类型管理</a>
						添加
					</p>
                </el-form-item>
				<el-form-item label="评价周期">
					<el-select v-model="queryParams.cycle" clearable placeholder="" class="label">
                        <el-option v-for="item in cycleList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="queryParams.zq" clearable placeholder="请选择周期" class="label">
                        <el-option v-for="item in zqList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="评价时间">
                    <el-date-picker v-model="queryParams.date" type="date" style="width: 240px;" placeholder="请选择时间段">
					</el-date-picker>
					<el-date-picker v-model="queryParams.date2" type="date" style="width: 240px;" placeholder="请选择时间段">
					</el-date-picker>
                </el-form-item>
            </el-form>
			<div class="wd">
				<p>评价维度</p>
				<div>设置</div>
			</div>
			<div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="维度名称" align="center">
                    </el-table-column>
                    <el-table-column prop="b" label="得分权重" align="center">
                    </el-table-column>
                    <el-table-column prop="c" label="参评人" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="totalPage>0">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
			<footer>
				<el-button style="width:120px;" type="primary" size="" @click='save()'>保存</el-button>
				<el-button style="margin-left:20px; width:120px;" size="" @click='toIndex()'>取消</el-button>
			</footer>
        </div>
    </div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
	props:['info'],
	components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				name: '',
				title: '',
				type:'',
				cycle:'1',
				zq:'',
				date:'',
				date2:'',
			},
			typeList:[],
			cycleList:[{label:'按月',id:'1'},{label:'按学期',id:'2'},{label:'按年',id:'3'},],
			zqList:[],
			tableData: [],
		}
	},
	computed:{

	},
	watch: {
		'info.classId':function(n,o){
			this.pageNum = 1;
			// this.getDataList();
		},
	},
	created() {
		
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				page:this.pageNum,
				limit:this.pageSize,
				classId:this.info.classId,
				courseName:this.queryParams.title,
				studentName:this.queryParams.name,
			}
			// let res= await api.studentCourseStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
			// console.log('学生分布详情',res)
		},
		searchFun(){
			this.pageNum = 1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toIndex(){
            this.$emit('to-index')
        },
		save(){},
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
			margin-right: 30px;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}

	::v-deep .el-form .el-input__inner {
		// width: 100%;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
	footer{
		margin-top: 30px;
		display: flex;
		justify-content: center;
	}
	.wd{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		div{
			color: #4991e1;
		}
	}
}
</style>
